import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicMarketCartOrderParamsRawI,
	LWApiPublicMarketCartDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { MARKET_CART_DETAILS_QUERY_KEY } from './useDetails';

const useCartOrder = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicMarketCartDetailsResultRawI,
		ApiErrorI,
		LWApiPublicMarketCartOrderParamsRawI
	>({
		mutationFn: (params) => api.market.cart.apiRaw.order(params),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: [MARKET_CART_DETAILS_QUERY_KEY, { uuid: data.uuid }],
			});
		},
		onError: snackbarError,
	});
};

export default useCartOrder;
